// extracted by mini-css-extract-plugin
module.exports = {"modal":"PopUp_modal__1jEo7","fullModal":"PopUp_fullModal__dY5SO","modalHeader":"PopUp_modalHeader__1SGoG"};